import React from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import App from './App';
// import App from './tests/image-upload-test'
import 'semantic-ui-css/semantic.css';
import '@performant-software/semantic-components/build/main.css';

const container = document.getElementById('root');
const root = createRoot(container!);

root.render(<App />);
